import { ButtonV3, theme } from '@provi/provi-components'
import styled from 'styled-components'

export const CardRequestContainer = styled.div`
  border: 2px solid ${theme.colors.bluePrimaryLight};
  border-radius: 5px;
  background: #ffffff;
  max-width: 704px;
  padding: 24px;
  font-family: 'Montserrat', sans-serif;
`
export const CardRequestTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.01em;
  margin: 0;
`

export const CardRequestRow = styled.div`
  border-bottom: 1px solid ${theme.colors.bluePrimaryLight};
  padding-bottom: 16px;
  padding-top: 16px;
  > div {
    margin-bottom: 8px;
    display: flex;
  }
  strong {
    margin-right: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #000;
  }
  span {
    font-weight: 500;
    font-size: 14px;
    color: #575757;
  }
  @media (max-width: 800px) {
    strong {
      margin-right: 8px;
    }
  }
`

export const CardRequestSubTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  display: flex;
  flex-direction: row;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  align-items: center;
  color: ${theme.colors.bluePrimary};
  svg {
    margin-right: 5px;
  }

  @media (max-width: 950px) {
    align-items: unset;
  }
`
export const CardRequestInfo = styled.div`
  background: ${theme.colors.bluePrimaryLight};
  padding: 12px;
  border-radius: 8px;
  margin-top: 24px;
  margin-bottom: 34px;
  font-size: 14px;
  position: relative;
  a {
    color: ${theme.colors.bluePrimaryDark};
    border-bottom: 1px solid ${theme.colors.bluePrimaryDark};
    margin-top: 8px;
    font-weight: 700;
  }
  svg {
    position: absolute;
  }
`

export const CardRequestCancellation = styled.a`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.02em;
  color: ${theme.colors.bluePrimary};
  &:hover {
    cursor: pointer;
  }
  > svg {
    margin-right: 8px;
  }
`

export const CardRequestWithdraw = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #000;
`
export const CardRequestValueContainer = styled.div`
  margin-top: 16px;
  font-size: 14px;
`

export const CardDivider = styled.div`
  width: 290px;
  height: 1px;
  margin-bottom: 12px;
  background-color: ${theme.colors.bluePrimary};
`

export const CardRequestValue = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 290px;
  margin-bottom: 8px;
  color: #575757;
  span {
    font-weight: 600;
    font-size: 14px;
    margin-right: 8px;
    color: #000;
  }
`

export const CardRequestAccount = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 290px;
  margin-bottom: 8px;
  color: #575757;
  span {
    font-weight: 600;
    font-size: 14px;
    color: #000;
    margin-right: 8px;
  }
`
export const CardNoRefund = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 290px;
  justify-content: space-between;
  span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.02em;
    color: #575757;
  }
`

export const CardRequestInfoText = styled.div`
  padding-left: 25px;
  line-height: 20px;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  div {
    margin-bottom: 8px;
  }
`

export const ModalBody = styled.div`
  padding: 24px 0;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  p {
    font-family: inherit;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.005em;
    color: black;
  }
`

export const Textinfo = styled.div`
  margin-top: 26px;
  align-items: flex-start;
  display: flex;
  position: relative;
  svg {
    margin-right: 6px;
    @media (max-width: 950px) {
      position: absolute;
    }
  }
  p {
    font-family: 'Montserrat', sans-serif;
    margin: 0px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.02em;
    color: #000000;

    @media (max-width: 950px) {
      margin-left: 30px;
    }
  }
`
export const CardRequestGridButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 800px) {
    flex-direction: column;

    a {
      order: 1;
      margin-top: 16px;
    }
  }

  a {
    color: ${theme.colors.bluePrimary};
    font-size: 14px;
    font-weight: 600;
    &:hover {
      cursor: pointer;
    }
  }
`
export const CardRequestButton = styled(ButtonV3)`
  background: ${theme.colors.bluePrimary};
  border-radius: 4px;
  width: 244px;
  cursor: pointer;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  color: #fff;

  @media (max-width: 800px) {
    width: 100%;
  }
`
